/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {WebhookCallExecutionRepresentation} from './webhookCallExecutionRepresentation';

export interface WebhookCallRepresentation {
  id?: string;
  proposalId?: string;
  proposalWebhookId?: string;
  eventId?: string;
  eventType?: string;
  timestamp?: number;
  payload?: string;
  status?: WebhookCallRepresentation.StatusEnum;
  executions?: Array<WebhookCallExecutionRepresentation>;
}
export namespace WebhookCallRepresentation {
  export type StatusEnum = 'SUCCESS' | 'PENDING' | 'FAILED' | 'UNRECOGNIZED';
  export const StatusEnum = {
    SUCCESS: 'SUCCESS' as StatusEnum,
    PENDING: 'PENDING' as StatusEnum,
    FAILED: 'FAILED' as StatusEnum,
    UNRECOGNIZED: 'UNRECOGNIZED' as StatusEnum,
  };
}
